export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/inc.fa102410.svg","height":20,"width":58,"blurWidth":0,"blurHeight":0};